import { Injectable } from '@angular/core';
import { CompanySelection } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { take, tap } from 'rxjs/operators';
import {
  DEFAULT_COOKIE_DOMAIN_VALUE,
  PERM_TYPE,
  PERSONAL
} from '../../constants/profile-selector/profile-selector-constants';
import { PROFILE_ACCOUNT_COOKIE } from '../../models/profile-selector/profile-selector.interface';
import { ProfileSelectorUtilHelperService } from './profile-selector-util-helper.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorUtilService extends ProfileSelectorUtilHelperService {
  switchBusinessAccountOverlay(
    companyName: string,
    permType: string,
    fromStandAlone: boolean
  ): void {
    //TODO need to switch it to idp-switching-account when approach D is consumed
    const elementTag = document.querySelector(
      'ngc-switching-account'
    ) as HTMLElement;
    if (this.switchBusinessAccountOverlayHelper(elementTag, permType)) {
      elementTag?.setAttribute('newProfileModalSelected', 'true');
      elementTag?.setAttribute('companyName', companyName);
    } else {
      elementTag?.setAttribute('newProfileModalSelected', 'false');
      elementTag?.removeAttribute('companyName');
      if (fromStandAlone) return;
      window.location.reload();
    }
  }

  getBusinessAccountState(): {
    businessAccountIndex: number;
    isBusiness: boolean;
  } {
    const accountCookie = this.cookieHelper.getAccountCookie('account');
    const parseAccount = JSON.parse(accountCookie);
    const businessAccountOptionsList =
      parseAccount['businessAccountOptionsList'];
    return {
      businessAccountIndex: businessAccountOptionsList['accountIndex']
        ? parseInt(businessAccountOptionsList['accountIndex'])
        : 0,
      isBusiness: parseAccount['isBusiness']
    };
  }

  transformAccountCookieObject(
    params: CompanySelection
  ): PROFILE_ACCOUNT_COOKIE {
    if (params.permType !== PERM_TYPE.P) {
      return {
        isBusiness: true,
        name: encodeURIComponent(params.companyName.toString()),
        businessAccountOptionsList: {
          isOaSmeAccount: params.isOaSmeAccount,
          partnerId: params.partnerId,
          accountIndex: params.accountIndex,
          restrictPaxToOne: params.restrictOnePax,
          displayInlineText: params.displayInlineText,
          disableMiles: params.disableMiles
        }
      };
    } else {
      return {
        isBusiness: false,
        name: encodeURIComponent(params.companyName.toString()),
        businessAccountOptionsList: {
          isOaSmeAccount: false,
          partnerId: PERSONAL,
          accountIndex: 0,
          restrictPaxToOne: false,
          displayInlineText: '',
          disableMiles: false
        }
      };
    }
  }

  setAccountCookie(params: CompanySelection): void {
    const accountType = JSON.stringify(
      this.transformAccountCookieObject(params)
    );
    this.userData
      .getAuthConfigContent()
      .pipe(
        take(1),
        tap((authConfig) => {
          this.cookieHelper.setCookieName(
            'account',
            accountType,
            0,
            true,
            '/',
            authConfig.COOKIE_DOMAIN_VALUE ?? DEFAULT_COOKIE_DOMAIN_VALUE
          );
        })
      )
      .subscribe();
  }

  getAdminUrl(aemContentForAdmin: string, userIdVal: string): string {
    const adminLinkUrl = aemContentForAdmin
      ? `${aemContentForAdmin}${userIdVal}`
      : '';
    return adminLinkUrl;
  }
}
